import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, Router, UrlTree } from '@angular/router';
import { Observable, of, switchMap } from 'rxjs';
import { AuthService } from 'app/core/auth/auth.service';

/**
 * Guards the public homepage ('/'): authenticated users are sent straight to
 * '/parties', guests are allowed through to see the marketing homepage.
 */
@Injectable({
    providedIn: 'root'
})
export class HomeGuard 
{
    constructor(
        private _authService: AuthService,
        private _router: Router
    )
    {
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree>
    {
        return this._check();
    }

    canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree>
    {
        return this._check();
    }

    private _check(): Observable<boolean | UrlTree>
    {
        return this._authService.check()
                   .pipe(
                       switchMap((authenticated) => {
                           if (authenticated)
                           {
                               return of(this._router.parseUrl('/parties'));
                           }

                           return of(true);
                       })
                   );
    }
}
